<template>
	<AppLayout :title="trans('menu.tools.accreditations')" :subtitle="trans('general.qr.scan')">
		<QrcodeStream @detect="scan"/>
	</AppLayout>
</template>
<script setup lang="ts">
import {route} from 'ziggy-js'
import {trans} from 'laravel-vue-i18n'
import {router} from '@inertiajs/vue3'
import {defineProps, ref, type Ref} from 'vue'
import AppLayout from '@/Layouts/AppLayout.vue'
import {QrcodeStream, type DetectedBarcode} from 'vue-qrcode-reader'

const props = defineProps<{
	prefix:string,
}>()

const prefix:Ref<string> = ref(props.prefix)

function scan(codes:Array<DetectedBarcode>):void{
	let next = true
	let i = 0
	while(next){
		let barcode = codes[i]
		if(barcode.format === 'qr_code'){
			let split = barcode.rawValue.split(':')
			if(split[0] === prefix.value){
				next = false
				router.get(route('tools.accreditations.enrollments.index', parseInt(split[1])))
			} else {
				console.log(trans('general.qr.invalid'))
			}
		}
		i++
	}
}
</script>
